"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.commonTitleTextFormatting = commonTitleTextFormatting;
exports.resolveAsset = resolveAsset;
exports.transformEcomLinks = transformEcomLinks;
exports.transformListLinks = transformListLinks;
exports.transformPageLinks = transformPageLinks;

var _lodash = require("lodash");

var _sentenceCase = require("sentence-case");

const isBrowser = typeof window !== `undefined`;

function resolveAsset(assetPath) {
  var _window$AEM_URL;

  if (!isBrowser) {
    return null;
  }

  return `${(_window$AEM_URL = window.AEM_URL) !== null && _window$AEM_URL !== void 0 ? _window$AEM_URL : ""}${assetPath !== null && assetPath !== void 0 ? assetPath : ""}`;
}

function commonTitleTextFormatting(titleText, level) {
  if (titleText) {
    let output = titleText;

    if (level !== 0 && level !== "0") {
      output = (0, _sentenceCase.sentenceCase)(titleText);
      output = (0, _lodash.replace)(output, "farmland", "Farmland");
    } // const sentence = sentenceCase(titleText);


    output = (0, _lodash.replace)(output, " and ", " & ");
    return output;
  }

  return "";
}

function transformEcomLinks(linksArray) {
  let level = 0;

  function formatData(links) {
    let parentSlug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    links === null || links === void 0 ? void 0 : links.forEach(i => {
      var _i$linkUrl, _i$linkUrl2, _i$linkUrl3;

      let friendlyPartURL = '';
      i.level = level;
      i.title = i === null || i === void 0 ? void 0 : i.linkText;
      i.target = i !== null && i !== void 0 && i.openInNewTab ? "_blank" : "_parent";
      i.children = i === null || i === void 0 ? void 0 : i.subMenus;

      switch (i === null || i === void 0 ? void 0 : (_i$linkUrl = i.linkUrl) === null || _i$linkUrl === void 0 ? void 0 : _i$linkUrl.type) {
        case "internalLink":
        case "externalLink":
          i.url = i === null || i === void 0 ? void 0 : (_i$linkUrl2 = i.linkUrl) === null || _i$linkUrl2 === void 0 ? void 0 : _i$linkUrl2.destinationUrl;
          break;

        case "categoryLink":
          i.url = i === null || i === void 0 ? void 0 : (_i$linkUrl3 = i.linkUrl) === null || _i$linkUrl3 === void 0 ? void 0 : _i$linkUrl3.destinationUrl;
          break; // if (i?.linkText === "ALL PRODUCTS") {
          //   i.url = `all/${i?.linkUrl?.categoryId}.c`;
          // }
          // else {
          //   const cleanLinkText = replace(i?.linkText, ' and ', ' ');
          //   friendlyPartURL = commonTitleTextFormatting(cleanLinkText, level).replace(/\s+/g, '-').toLowerCase();
          //   if(i.level === 1) { 
          //     i.url = `all/${friendlyPartURL}/${i?.linkUrl?.categoryId}.c`;
          //   }
          //   else {
          //     i.url = `all/${parentSlug}/${friendlyPartURL}/${i?.linkUrl?.categoryId}.c`;
          //   }
          // }

          break;

        default:
          i.url = `#`;
          break;
      }

      i === null || i === void 0 ? true : delete i.linkText;
      i === null || i === void 0 ? true : delete i.openInNewTab;
      i === null || i === void 0 ? true : delete i.linkUrl;
      i === null || i === void 0 ? true : delete i.imageLink;
      i === null || i === void 0 ? true : delete i.subMenus;

      if (i !== null && i !== void 0 && i.children) {
        level++;
        formatData(i === null || i === void 0 ? void 0 : i.children, friendlyPartURL);
        level--;
      }
    });
    return links;
  }

  return formatData(linksArray);
}

function transformPageLinks(linksArray) {
  function formatData(links) {
    links === null || links === void 0 ? void 0 : links.forEach(i => {
      var _i$description;

      i.target = (_i$description = i === null || i === void 0 ? void 0 : i.description) !== null && _i$description !== void 0 ? _i$description : "_parent";
      i.title = commonTitleTextFormatting(i === null || i === void 0 ? void 0 : i.title, i === null || i === void 0 ? void 0 : i.level);
      i === null || i === void 0 ? true : delete i.description;

      if (i !== null && i !== void 0 && i.children) {
        formatData(i === null || i === void 0 ? void 0 : i.children);
      }
    });
    return links;
  }

  return formatData(linksArray);
}

function transformListLinks(linksArray) {
  return linksArray === null || linksArray === void 0 ? void 0 : linksArray.map(linkGroup => {
    var _linkGroup$linkList;

    let children = [];
    let level = 1;
    linkGroup === null || linkGroup === void 0 ? void 0 : (_linkGroup$linkList = linkGroup.linkList) === null || _linkGroup$linkList === void 0 ? void 0 : _linkGroup$linkList.forEach(child => {
      if (child !== null && child !== void 0 && child.label && (child === null || child === void 0 ? void 0 : child.label) !== "") {
        children.push({
          level,
          target: child === null || child === void 0 ? void 0 : child.target,
          title: commonTitleTextFormatting(child === null || child === void 0 ? void 0 : child.label, level),
          url: child === null || child === void 0 ? void 0 : child.path,
          children: []
        });
      }
    });
    level = 0;
    return {
      level: 0,
      target: linkGroup === null || linkGroup === void 0 ? void 0 : linkGroup.linkGroupTarget,
      title: commonTitleTextFormatting(linkGroup === null || linkGroup === void 0 ? void 0 : linkGroup.linkGroupLabel),
      url: linkGroup === null || linkGroup === void 0 ? void 0 : linkGroup.linkGroupLink,
      children
    };
  });
}